module.exports = __webpack_public_path__ + "img/2010 winteressen 010.c698bd6a.jpg";